<template>
  <div>
  <div v-if="!isUpload">
    <v-card flat :loading="loadLaudo" v-if="status != 'L'">
      <v-card-actions>
        <v-btn color="red" text @click="voltar()">
          <v-icon left color="red">keyboard_return</v-icon> VOLTAR
        </v-btn>
        <v-spacer />
        <!-- <v-select class="pt-6 mb-0 mt-0 mr-1" dense v-model="status" :items="statusLaudo" label="Status"
          item-text="tipo" item-value="status" outlined></v-select> -->
        <!-- <v-btn class="mr-1" color="blue" outlined @click="gerarMensagemComparecimento">
          <v-icon left>add</v-icon> Data
        </v-btn> -->
        <v-menu v-model="menu" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              Meus Modelos
            </v-btn>
          </template>
          <v-card>
            <v-container>
              <v-autocomplete ref="autocomplete" class="mt-2" outlined dense v-model="content" item-text="titulo"
                item-value="descricao" :items="modelos" label="Modelo" @focus="menu = true">
              </v-autocomplete>
            </v-container>
          </v-card>
        </v-menu>
      </v-card-actions>

      <v-sheet min-height="60vh" rounded="lg">
        <div class="pa-1">
          <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
            placeholder="Descrição …" />
        </div>
      </v-sheet>
      <v-divider />
      <v-card-actions>
        <v-btn :loading="loadSave" disabled color="primary"><v-icon left>mdi-pencil</v-icon> assinar digitalmente</v-btn>
        <v-btn disabled text color="blue" @click="isUpload = true"><v-icon large left>drive_folder_upload</v-icon>anexos</v-btn>
        <v-spacer />
        <v-switch
          color="green"
          v-model="status"
          label="LIBERAR"
          value="LX"
        ></v-switch>
        <v-btn class="ml-2" text readonly :loading="loadSave" :disabled="content.length < 8" @click="idLaudo == null ? salvarLaudo() : editarLaudo()"
          color="blue">
          <v-icon large rigth v-text="idLaudo != null? 'save_as':'save'"></v-icon>
          salvar
        </v-btn>
      </v-card-actions>

      <v-alert dense v-show="alert.visible" :type="alert.type">
        {{ alert.message }}
      </v-alert>
    </v-card>
    <v-card v-else flat :loading="loadLaudo">
      <v-card-actions>
        <v-btn :disabled="idExamesOs == null && content.length > 7" color="red" text @click="voltar()">
          <v-icon left color="red">keyboard_return</v-icon> VOLTAR
        </v-btn>
        </v-card-actions>
        <v-divider />
      <v-card-text>
      <div v-html="content"></div>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Alerta de liberação
        </v-card-title>

        <v-card-text>
          Atenção: Após a liberação do laudo, não será possível realizar alterações. Certifique-se de revisar todas as informações antes de concluir o processo. Deseja prosseguir?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialog = false">
            Voltar
          </v-btn>
          <v-btn
            color="blue"
            text
            @click="idLaudo == null ? salvarLaudo() : editarLaudo()"
          >
            <v-icon left>save</v-icon>
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   </div>
   <uploadLaudo @voltar="isUpload = false" v-if="isUpload" :ficha="{ idPaciente: paciente.idPaciente, idOrdemServico: paciente.idOrdemServico }" :consulta="consulta"></uploadLaudo>
  </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import { EventBus } from '../../main'
import uploadLaudo from '../medico/uploadLaudo.vue'
import 'tiptap-vuetify/dist/main.css'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'
import socketService from '../../services/socket.service'
import { getToken } from '../../store/auth'

export default {
  name: 'Editor',
  components: { TiptapVuetify, uploadLaudo },
  props: {
    paciente: Object,
    consulta: Object,
    userAux: Object
  },
  data: () => ({
    isImprime: false,
    menu: false,
    loadCadastro: false,
    idLaudo: null,
    loadLaudo: false,
    content: '',
    isUpload: false,
    dialog: false,
    idExamesOs: null,
    socket: '',
    loadSocket: false,
    modelos: [],
    loadSave: false,
    status: 'X',
    alert: { visible: false, message: '', type: '' },
    extensions: [
      History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
      [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
    ],
    debounceTimeout: null // Adicionado para debounce
  }),
  mounted () {
    this.listarModelosProntuario()

    // this.socket = io.connect(socketService.SOCKET_URL, {
    //   query: {
    //     token: getToken()
    //   }
    // })
    // this.chamarSocket()
    this.buscarLaudoClinicoPorIdExamesOS()
  },
  methods: {
    buscarLaudoClinicoPorIdExamesOS () {
      console.log('buscarLaudoClinicoPorIdExamesOS', this.consulta)
      
      const idExameOS = this.consulta.idexamesos ? this.consulta.idexamesos : this.consulta.idExamesOS
      console.log('idExamesOsEncontrado: ', idExameOS)
      medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExameOS).then(r => {  
        console.log(r.data);
        
        if (r.status == 200) {
          this.idExamesOs = r.data.idExamesOS
          this.content = r.data.descricaoLaudo
          this.status = r.data.status
          this.idLaudo = r.data.id
        }
      }).finally(() => {
        // this.loadLaudo = false
      })
    },
    editarLaudo () {
      this.dialog = false
      this.loadSave = true
      medicoService.medico.editarLaudoClinico(this.idExamesOs, this.content, this.status === 'LX' ? 'L' : 'X').then(r => {
        if (r.status === 200) {
          this.showAlert('Laudo editado com sucesso!', 'info', 3000, () => this.voltar())
        }
      }).finally(() => {
        EventBus.$emit('reloadQuantidadeLaudosTec')
        this.loadSave = false
      })
    },
    chamarSocket () {
      this.socket.on(
        'respostaCadastroTexto',
        function (response) {
          console.log('skt respostaCadastroTexto: ', response, response.message.idExamesOs, this.consulta.idexamesos)
          this.loadSocket = false
          if (response.status === 'success' && response.message.idExamesOs == this.consulta.idexamesos) {
            this.idLaudo = response.message.id
            console.log('entrou: ', this.idLaudo)
          }
        }.bind(this)
      )
      this.socket.on('connect_error', () => {
        this.mensagemNotificacaoSocket = 'aguardando conexao'
      })

      this.socket.on(
        'disconnect',
        function () {
          this.mensagemNotificacaoSocket = 'desconectado'
        }.bind(this)
      )
    },
    salvarLaudo () {
      this.loadSave = true
      this.dialog = false
      const idExameOS = this.consulta.idexamesos ? this.consulta.idexamesos : this.consulta.idExamesOS
      medicoService.medico.cadastrarLaudoClinico({
        idExamesOs: idExameOS,
        idPaciente: this.paciente.idPaciente,
        idEmpresa: this.userAux.idEmpresa,
        idUnidade: this.userAux.idUnidade,
        idPrestador: null,
        idUsuario: this.userAux.id,
        descricao: this.content,
        status: this.status === 'LX' ? 'L' : 'X'
      }).then(r => {
        if (r.status === 200) {
          this.showAlert('Laudo cadastrado com sucesso!', 'success', 3000, () => this.voltar())
        }
      }).finally(() => {
        this.loadSave = false
      })
    },
    showAlert (message, type, timeout = 3000, callback) {
      this.alert = { visible: true, message, type }
      setTimeout(() => {
        this.alert.visible = false
        if (callback) callback()
      }, timeout)
    },
    gerarMensagemComparecimento () {
      const hoje = new Date()
      const dataFormatada = hoje.toLocaleDateString('pt-BR')
      const horaFormatada = hoje.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      this.content += `${dataFormatada}, às ${horaFormatada}`
    },
    listarModelosProntuario () {
      this.loadModelos = true
      console.log('LAUDO', this.userAux.id, this.consulta.idExame)
      medicoService.medico.listarModelosProntuario('LAUDO', this.userAux.id, this.consulta.idExame).then(({ status, data }) => {
        console.log('Laudo: ', data)
        if (status === 200 && data.status !== 'error') {
          this.modelos = data
        }
      }).finally(() => {
        this.loadModelos = false
      })
    },
    voltar () {
      this.$emit('voltar', true)
    },
    // Função de debounce
    debounce (func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimeout)
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait)
      }
    }
  },
  watch: {
    
    status (val) {
      if (val === 'LX' || val === 'L') {
        val = 'L'
      } else {
        val = 'X'
      }
      /*

      this.socket.emit('escutarEventoTexto', {
        idExamesOS: this.consulta.idexamesos,
        idPaciente: this.paciente.idPaciente,
        idEmpresa: this.userAux.idEmpresa,
        idUnidade: this.userAux.idUnidade,
        idPrestador: null,
        idUsuario: this.userAux.id,
        descricao: this.content,
        idLaudo: this.idLaudo,
        status: val,
        tipo: 'LAUDO'
      })
    },
    content (newContent, oldContent) {
      if (newContent !== oldContent && this.status !== 'L') {
        this.loadSocket = true
        this.debounce(() => {
          this.socket.emit('escutarEventoTexto', {
            idExamesOS: this.consulta.idexamesos,
            idPaciente: this.paciente.idPaciente,
            idEmpresa: this.userAux.idEmpresa,
            idUnidade: this.userAux.idUnidade,
            idPrestador: null,
            idUsuario: this.userAux.id,
            descricao: this.content,
            idLaudo: this.idLaudo,
            status: this.status === 'LX' ? 'L' : 'X',
            tipo: 'LAUDO'
          })
        }, 2000)()
      }
    } */
    }
  }
}
</script>
